import React, { useState } from "react";
import ChatList from "../Components/ChatList/ChatList";
import ChatWindow from "../Components/chat/ChatWindow";
import ActualizarMemoria from "../Components/ActualizarMemoria/ActualizarMemoria";
import RespuestasAutomaticas from "../Components/RespuestasAutomaticas/RespuestasAutomaticas";
import Swal from "sweetalert2";
import "./Dashboard.css";

export default function Dashboard({ onLogout }) {
  const [chatSeleccionado, setChatSeleccionado] = useState(null);
  const [chatAbierto, setChatAbierto] = useState(false);
  const [isPausing, setIsPausing] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [mostrarMemoria, setMostrarMemoria] = useState(false);
  const [mostrarRespuestas, setMostrarRespuestas] = useState(false);

  const cerrarChat = () => setChatAbierto(false);
  const abrirChat = () => setChatAbierto(true);

  // 1. CONTROLAR PAUSA/REACTIVACIÓN DEL BOT (NGROK)
  const controlarBot = async (estado) => {
    const accion = estado ? "reactivar" : "pausar";

    const confirm = await Swal.fire({
      title: `¿Seguro que quieres ${accion} el bot?`,
      text: "Esto afectará todas las conversaciones activas.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    setIsPausing(true);

    Swal.fire({
      title: "Procesando...",
      text: "Enviando orden al bot",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await fetch(
        "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Pausa-LaPile",
        {
          method: "POST",
          mode: "no-cors",
          body: JSON.stringify({ estado }),
        }
      );

      Swal.fire({
        icon: "success",
        title: estado ? "Bot reactivado" : "Bot pausado",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo controlar el bot.",
      });
    } finally {
      setIsPausing(false);
    }
  };

  // 2. OBTENER QR Y DETECTAR CONEXIÓN AUTOMÁTICA
  const mostrarQR = async () => {
    Swal.fire({
      title: "Generando QR...",
      text: "Conectando con la instancia de Evolution API",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    let chequeoInterval;

    try {
      // Corrección limpia de la petición Fetch async/await sin mezclar .then()
      const response = await fetch("https://boastful-recast-straggler.ngrok-free.dev/instance/connect/cliente1", {
        method: "GET",
        headers: {
          "apikey": "123456",
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true" 
        }
      });

      if (!response.ok) {
        throw new Error("No se pudo obtener una respuesta válida del servidor.");
      }

      const data = await response.json();
      console.log("Datos de la instancia:", data); // Esto te mostrará el objeto limpio en consola

      if (data.base64) {
        Swal.fire({
          title: "Vincula tu WhatsApp",
          text: "Escanea este código antes de que expire (40 seg).",
          imageUrl: data.base64, // Aquí SweetAlert2 renderiza directamente el base64 de tu imagen
          imageWidth: 250,
          imageHeight: 250,
          imageAlt: "Código QR",
          confirmButtonText: "Cancelar",
          confirmButtonColor: "#d33",
          allowOutsideClick: false,
          didOpen: () => {
            // Consulta de estado automática cada 2 segundos
            chequeoInterval = setInterval(async () => {
              try {
                const resEstado = await fetch("https://boastful-recast-straggler.ngrok-free.dev/instance/connectionState/cliente1", {
                  method: "GET",
                  headers: {
                    "apikey": "123456",
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "true" // Agregado también aquí para evitar bloqueos intermedios
                  }
                });

                if (resEstado.ok) {
                  const estadoData = await resEstado.json();
                  
                  // Si Evolution API confirma que el estado es "open", ya se conectó
                  if (estadoData.instance && estadoData.instance.state === "open") {
                    clearInterval(chequeoInterval);

                    Swal.fire({
                      icon: "success",
                      title: "¡Conectado exitosamente!",
                      text: "Tu WhatsApp ya está vinculado con el asistente.",
                      timer: 3000,
                      showConfirmButton: false
                    });
                  }
                }
              } catch (err) {
                console.error("Error revisando estado de conexión:", err);
              }
            }, 2000);
          },
          willClose: () => {
            clearInterval(chequeoInterval);
          }
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "Instancia ya conectada",
          text: "Parece que esta instancia ya tiene un número activo.",
        });
      }
    } catch (error) {
      console.error("Error en mostrarQR:", error);
      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No se pudo obtener el QR correctamente.",
      });
    }
  };

  // 3. DESCONECTAR NÚMERO / LOGOUT (EVOLUTION API)
  const desconectarInstancia = async () => {
    const confirm = await Swal.fire({
      title: '¿Desconectar WhatsApp?',
      text: "El bot dejará de funcionar hasta que vuelvas a vincular un número.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, desconectar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
      title: "Desconectando...",
      text: "Cerrando sesión en Evolution API",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await fetch("https://boastful-recast-straggler.ngrok-free.dev/instance/logout/cliente1", {
        method: "DELETE",
        headers: {
          "apikey": "123456",
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true"
        }
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Desconectado",
          text: "El número ha sido desvinculado correctamente.",
          timer: 2500,
          showConfirmButton: false,
        });
      } else {
        const data = await response.json();
        throw new Error(data.message || "Error al desconectar");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al desconectar",
        text: "Hubo un problema de conexión con el servidor.",
      });
    }
  };

  return (
    <div className="dashboard">
      <aside className="dashboard__sidebar">
        <div className="sidebar__header">
          <div className="sidebar__avatar">
            <img src="/logo192.png" alt="Tresatec" className="sidebar__avatar-img" />
          </div>
          <span className="sidebar__title">Control de Asistente</span>
          <button className="icon-btn" onClick={onLogout} title="Cerrar sesión">
            ⏻
          </button>
        </div>

        <div className="sidebar__search">
          <input
            type="text"
            placeholder="Buscar chats..."
            className="search__input"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>

        <div className="sidebar__chats custom-scroll">
          <ChatList
            search={busqueda}
            selectedChatId={chatSeleccionado}
            onSelect={(chat) => {
              setChatSeleccionado(chat);
              setMostrarMemoria(false);
              setMostrarRespuestas(false);
              abrirChat();
            }}
          />
        </div>
      </aside>

      <main className="dashboard__main">
        {mostrarMemoria ? (
          <ActualizarMemoria onBack={() => setMostrarMemoria(false)} />
        ) : mostrarRespuestas ? (
          <RespuestasAutomaticas onBack={() => setMostrarRespuestas(false)} />
        ) : (
          <>
            {chatSeleccionado && (
              <div className="main__header">
                <div className="header__info">
                  <div className="header__avatar">
                    <img src="/logo192.png" alt="Tresatec" className="header__avatar-img" />
                  </div>
                  <div>
                    <h2 className="header__title">{chatSeleccionado}</h2>
                    <span className="header__status">En línea</span>
                  </div>
                </div>

                {chatAbierto && (
                  <button className="close-chat-btn" onClick={cerrarChat}>
                    ❌
                  </button>
                )}
              </div>
            )}

            <div className="main__content">
              {chatAbierto && chatSeleccionado ? (
                <ChatWindow chatId={chatSeleccionado} />
              ) : (
                <div className="bot-controls__container">
                  <div className="bot-controls__card">
                    <h3 className="card__title">Panel de control del Bot</h3>
                    <p className="card__subtitle">
                      Gestiona la inteligencia del asistente
                    </p>

                    <div className="controls__group">
                      <button
                        className="control-btn control-btn--pause"
                        onClick={() => controlarBot(false)}
                        disabled={isPausing}
                      >
                        ⏸️ Pausar inteligencia
                      </button>

                      <button
                        className="control-btn control-btn--resume"
                        onClick={() => controlarBot(true)}
                        disabled={isPausing}
                      >
                        ▶️ Reactivar inteligencia
                      </button>

                      <button
                        className="control-btn control-btn--respuestas"
                        onClick={() => setMostrarRespuestas(true)}
                      >
                        ⚡ Respuestas automáticas →
                      </button>

                      <button
                        className="control-btn control-btn--memory"
                        onClick={() => setMostrarMemoria(true)}
                      >
                        🧠 Actualizar memoria →
                      </button>

                      {/* BOTÓN ESCANEAR QR */}
                      <button
                        className="control-btn control-btn--qr"
                        onClick={mostrarQR}
                        style={{ backgroundColor: '#25D366', color: 'white', borderColor: '#25D366' }}
                      >
                        📱 Escanear QR
                      </button>

                      {/* BOTÓN DESCONECTAR */}
                      <button
                        className="control-btn control-btn--logout"
                        onClick={desconectarInstancia}
                        style={{ backgroundColor: '#dc3545', color: 'white', borderColor: '#dc3545' }}
                      >
                        🔌 Desconectar WhatsApp
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </main>
    </div>
  );
}